interface PixelProps {
  code: string;
}

const GSCVerification = ({ code }: PixelProps) => {
  const trimmedCode = code?.trim();
  return trimmedCode ? <meta name="google-site-verification" content={trimmedCode} /> : null;
};

export default GSCVerification;
